module.exports = __webpack_public_path__ + "img/btn_auto_start.7f220b41.jpg";